import i18n from 'modules/core/lib/i18n'

import withCustomizationFields, {
  WithCustomizationFieldsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import withFieldPermissions, {
  WithFieldPermissionsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

import LocationInput from './LocationInput'

interface Props extends WithCustomizationFieldsProps, WithFieldPermissionsProps {
  onPlaceSelected?: (place: { lat: number; lng: number }) => void
  onInputChange?: () => void
}

const ToField = (props: Props) => {
  return (
    <LocationInput
      {...props}
      fieldName="to"
      label={i18n.t('expenses_v2.forms.fields.to.label')}
      placeholder={i18n.t('expenses_v2.forms.fields.to.placeholder')}
    />
  )
}

export default withCustomizationFields(withFieldPermissions(ToField, 'to'))
